/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListForumThreads200ResponseLinks
 */
export interface ListForumThreads200ResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseLinks
     */
    last?: string;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseLinks
     */
    prev?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ListForumThreads200ResponseLinks
     */
    next?: string | null;
}

/**
 * Check if a given object implements the ListForumThreads200ResponseLinks interface.
 */
export function instanceOfListForumThreads200ResponseLinks(value: object): value is ListForumThreads200ResponseLinks {
    return true;
}

export function ListForumThreads200ResponseLinksFromJSON(json: any): ListForumThreads200ResponseLinks {
    return ListForumThreads200ResponseLinksFromJSONTyped(json, false);
}

export function ListForumThreads200ResponseLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListForumThreads200ResponseLinks {
    if (json == null) {
        return json;
    }
    return {
        
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'prev': json['prev'] == null ? undefined : json['prev'],
        'next': json['next'] == null ? undefined : json['next'],
    };
}

export function ListForumThreads200ResponseLinksToJSON(json: any): ListForumThreads200ResponseLinks {
    return ListForumThreads200ResponseLinksToJSONTyped(json, false);
}

export function ListForumThreads200ResponseLinksToJSONTyped(value?: ListForumThreads200ResponseLinks | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first': value['first'],
        'last': value['last'],
        'prev': value['prev'],
        'next': value['next'],
    };
}

